import { Check } from '@mui/icons-material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import staticData from '../../../resources/static.json';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import SearchIcon from '@mui/icons-material/Search';
import CloseIcon from '@mui/icons-material/Close';
import {
  Autocomplete,
  Box,
  Button,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Grid,
  IconButton,
  InputAdornment,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Menu,
  MenuItem,
  Step,
  StepLabel,
  Stepper,
  TextField,
  Typography,
  Link,
  FormControl,
  InputLabel,
  RadioGroup,
  Select,
  FormControlLabel,
  Radio,
  Tooltip
} from '@mui/material';
import React, { useEffect, useState } from 'react';
import { batch } from 'react-redux';
import { PopupComponent } from 'src/components/common/PopupComponent';
import { useTab } from 'src/components/hooks/useTab';
import { useGetCodeListDataQuery } from 'src/services/codeList';
import {
  useGetAllPatientDetailsMutation,
  useGetPatientIdMutation,
  useGetPrescreenIdMutation,
  useGetSubjectIDMutation
} from 'src/services/patientDetails';
import { useAppDispatch, useAppSelector } from 'src/store';
import { hideLoader, showLoader } from 'src/store/Loader';
import { setMessage } from 'src/store/Message';
import { setPath } from 'src/store/Navigation';
import { setHierarchyPageDetailsLoaded } from 'src/store/SelectedHierarchy';
import {
  setFormLibraryDataIsOpen,
  clearCurrentPatientTrailTab,
  clearFormLibraryMainData,
  clearIntrialPatientInfo,
  clearSelectedIntrialPatient,
  setPlannedDate,
  setActiveStep
} from 'src/store/SelectedIntrialPatient';
import {
  useGenerateSubjectIDMutation,
  useActivateCRFMutation,
  useEnrollSubjectMutation,
  usePreTrialEvaluationMutation
} from 'src/services/subjectToolkit';
import { useGetLatestSubjectIDMutation } from 'src/services/workarea';
import PendingOutlined from '@mui/icons-material/PendingOutlined';
import { usePermissionWrapper } from 'src/components/hooks/usePermissionWrapper';
import { clearSubjectInfo, setSelectedSubject } from 'src/store/SelectedSubject';
import { usePreferedDateFormat } from 'src/util/DateFormatter';
import { useFieldTranslation } from '../../fields/useFieldTranslation';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import PatientTrailNoteBookTabs from './PatientTrailNoteBookTabs';
import FormLibraryData from './formLibraryData';
import { SITE_HIERARCHY_VALUE, STUDY_HIERARCHY_VALUE } from 'src/types/Site';
import moment from 'moment';
export interface IPatientHierarchy {
  study_id: string;
  site_id: string;
  country: string;
}
export const PatientTrialNoteBook: React.FC = () => {
  const [openprocess, setOpenProcess] = React.useState(false);
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const [selectedIndex, setSelectedIndex] = useState(0);
  const [option, setOption] = useState<any>([]);
  const [searchScope, setSearchScope] = useState([]);
  const [screeningDate, setScreeningDate] = useState<Date>(new Date());
  const [planningDate, setPlanningDate] = useState<Date>(new Date());
  const [selection, setSelection] = useState('Patient Identifier');
  const steps = staticData.PatientTrialNoteBookData.steps;
  const rowData = staticData.PatientTrialNoteBookData.rowData;
  const [patinetDetails, setPatientDetails] = useState<any>({});
  const open = Boolean(anchorEl);
  const selectedStudy: any = useAppSelector(state => state.site.selectedStudy);
  const selectedCountry = useAppSelector(state => state.site.selectedCountry);
  const selectedSite = useAppSelector(state => state.site.selectedSite);
  const user = useAppSelector(state => state.user.user);
  const currentHierarchyLevel = useAppSelector(state => state.site.currentHierarchyLevel);
  const selectedInTrialPatientID = useAppSelector(state => state.SelectedIntrialPatientInfo.selectedIntrialPatient);
  const [patient, setPatient] = useState(selectedInTrialPatientID || '');
  const activeStep = useAppSelector(state => state.SelectedIntrialPatientInfo.activeStep);
  const isHierarchyLevelClosed: boolean = useAppSelector(state => state.site.isHierarchyLevelClosed);
  const sitePermissionData = useAppSelector(state => state.site.sitePermissionData);
  const { checkPermission } = usePermissionWrapper();
  const { unSavedWarning } = useFieldTranslation();
  const selectedSubjectInfo = useAppSelector(state => state.selectedSubjectInfo);
  const hierarchyStudy = useAppSelector(state => state.selectedHierarchy.hierarchyStudy);
  const hierarchyCountry = useAppSelector(state => state.selectedHierarchy.hierarchyCountry);
  const hierarchySite = useAppSelector(state => state.selectedHierarchy.hierarchySite);
  const [isScreenDisabled, setIsScreenDisabled] = useState(false);

  const {
    data: codeListData,
    isError: codeListIsError,
    error: codeListError,
    isLoading: codeListIsLoading
  } = useGetCodeListDataQuery('TSDAPSS');
  const [getAllPatientDetailsAPI, { data: allPatientDetails, isError, error, isLoading }] =
    useGetAllPatientDetailsMutation();
  const [
    getPatientDataAPI,
    { data: patientIdData, isError: patientIdIsError, error: patientIdError, isLoading: patientIdIsLoading }
  ] = useGetPatientIdMutation();
  const [
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    getPrescreenDataAPI,
    { data: prescreenIdData, isError: prescreenIdIsError, error: prescreenIdError, isLoading: prescreenIdIsLoading }
  ] = useGetPrescreenIdMutation();
  const [
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    getSubjectDataAPI,
    { data: subjectIDData, isError: subjectIDIsError, error: subjectIDError, isLoading: subjectIDIsLoading }
  ] = useGetSubjectIDMutation();

  const [
    getLatestSubjectID,
    {
      data: latestSubjectID,
      isError: latestSubjectIDIsError,
      error: latestSubjectIDError,
      isLoading: latestSubjectIDIsLoading,
      isSuccess: latestSubjectIDIsSuccess
    }
  ] = useGetLatestSubjectIDMutation();
  const [
    generateSubjectID,
    {
      data: generateSubjectIDData,
      isError: generateSubjectIDIsError,
      error: generateSubjectIDError,
      isLoading: generateSubjectIDIsLoading,
      isSuccess: generateSubjectIDIsSuccess
    }
  ] = useGenerateSubjectIDMutation();

  const [
    activateCRF,
    {
      data: activateCRFData,
      isError: activateCRFIsError,
      error: activateCRFError,
      isLoading: activateCRFIsLoading,
      isSuccess: activateCRFIsSuccess
    }
  ] = useActivateCRFMutation();

  const [
    enrollSubject,
    {
      data: enrollSubjectData,
      isError: enrollSubjectIsError,
      error: enrollSubjectError,
      isLoading: enrollSubjectIsLoading,
      isSuccess: enrollSubjectIsSuccess
    }
  ] = useEnrollSubjectMutation();

  const [
    PreTrialEvaluation,
    {
      data: preTrialEvaluationData,
      isError: preTrialEvaluationIsError,
      error: preTrialEvaluationError,
      isLoading: preTrialEvaluationLoading,
      isSuccess: preTrialEvaluationIsSuccess
    }
  ] = usePreTrialEvaluationMutation();
  const idsData = useAppSelector(state => state.SelectedIntrialPatientInfo.Core_FICS_patient_identifier);
  const [ids, setIds] = useState(idsData);
  const { getServerDateOrInvalidDayJs, userPreferedDateFormat, preferedDateFormat } = usePreferedDateFormat();
  const isBackButton = useAppSelector(state => state.SelectedIntrialPatientInfo.isBackButton);
  const formLibraryDataIsOpen = useAppSelector(state => state.SelectedIntrialPatientInfo.formLibraryDataIsOpen);
  const formLibraryMainData = useAppSelector(state => state.SelectedIntrialPatientInfo.formLibraryMainData);

  const selectedPatientTrailTab = useAppSelector(state => state.SelectedIntrialPatientInfo.currentPatientTrailTab);
  const assignedForms = useAppSelector(state => state.SelectedIntrialPatientInfo.assignedFormsPatientTrail);
  const [formActionConfirmationPopup, setFormActionConfirmationPopup] = useState(false);
  const dispatch = useAppDispatch();
  const preTrailplannedDate = useAppSelector(state => state.SelectedIntrialPatientInfo.plannedDate);
  const { setTabVal, tabsData } = useTab();
  useEffect(() => {
    if (codeListData) {
      const searchScope = codeListData.map((el: any) => el.code_list_value);
      setSearchScope(searchScope);
    }
  }, [codeListData]);

  useEffect(() => {
    if (allPatientDetails) {
      const temp: any = allPatientDetails.selected_data;
      if (selection === 'Patient Identifier') {
        const patientId = temp?.map((elem: any) => elem?.patient?.patient_identifier)?.filter((ele: any) => ele);
        setOption([...new Set(patientId)]);
      } else if (selection === 'Prescreening ID') {
        const prescreenId = temp?.map((elem: any) => elem?.patient?.prescreening_id)?.filter((ele: any) => ele);
        setOption([...new Set(prescreenId)]);
      } else if (selection === 'Subject ID') {
        const subjectID = temp?.map((elem: any) => elem?.patient?.subject_id)?.filter((ele: any) => ele);
        setOption([...new Set(subjectID)]);
      }
    } else {
      setOption([]);
    }
  }, [allPatientDetails]);

  useEffect(() => {
    if (patientIdData) {
      dispatch(setHierarchyPageDetailsLoaded(true));
      dispatch(setPlannedDate(patientIdData.planned_screening_date));
      setPatientDetails(patientIdData);
    }
  }, [patientIdData]);

  useEffect(() => {
    if (patient) {
      dispatch(clearCurrentPatientTrailTab());
    }
  }, [patient]);

  useEffect(() => {
    if (prescreenIdData) {
      setPatientDetails(prescreenIdData);
    }
  }, [prescreenIdData]);

  useEffect(() => {
    if (subjectIDData) {
      setPatientDetails(subjectIDData);
    }
  }, [subjectIDData]);

  useEffect(() => {
    dispatch(setPlannedDate(null));
    if (ids && selectedStudy !== null && selectedSite !== null && selectedCountry !== null) {
      setPatient(ids);
      getPatientDataAPI({
        patient_id: ids,
        study_id: hierarchyStudy ? hierarchyStudy : selectedStudy,
        country: hierarchyCountry ? hierarchyCountry : selectedCountry,
        site_id: hierarchySite ? hierarchySite : selectedSite,
        search_scope: 'PATIENT_IDENTIFIER',
        application: process.env.REACT_APP_NAME_TEMP,
        application_section: process.env.REACT_APP_NAME_TEMP,
        application_module_section: 'PATIENT TRIAL NOTEBOOK'
      });
    } else if (selectedSubjectInfo?.patient_identifier) {
      setIds(selectedSubjectInfo.patient_identifier);
      setPatient(selectedSubjectInfo.patient_identifier);
      getPatientDataAPI({
        patient_id: selectedSubjectInfo.patient_identifier,
        study_id: selectedStudy,
        country: selectedCountry,
        site_id: selectedSite,
        search_scope: 'PATIENT_IDENTIFIER',
        application: process.env.REACT_APP_NAME_TEMP,
        application_section: process.env.REACT_APP_NAME_TEMP,
        application_module_section: 'PATIENT TRIAL NOTEBOOK'
      });
    }
  }, [ids, selectedSite, selectedInTrialPatientID, currentHierarchyLevel, selectedStudy, selectedCountry]);

  useEffect(() => {
    dispatch(setHierarchyPageDetailsLoaded(false));
    dispatch(setPlannedDate(null));
    if (currentHierarchyLevel === SITE_HIERARCHY_VALUE && !isHierarchyLevelClosed) {
      getAllPatientDetailsAPI({
        search_scope:
          selection === 'Patient Identifier'
            ? 'PATIENT_IDENTIFIER'
            : selection === 'Prescreening ID'
            ? 'PRESCREENING_ID'
            : 'SUBJECT_ID',
        study_id: selectedStudy,
        country: selectedCountry,
        site_id: selectedSite,

        application: process.env.REACT_APP_NAME_TEMP,
        application_section: process.env.REACT_APP_NAME_TEMP,
        application_module_section: 'PATIENT TRIAL NOTEBOOK'
      });
    } else if (isHierarchyLevelClosed) {
      getAllPatientDetailsAPI({
        search_scope:
          selection === 'Patient Identifier'
            ? 'PATIENT_IDENTIFIER'
            : selection === 'Prescreening ID '
            ? 'PRESCREENING_ID'
            : 'SUBJECT_ID',
        study_id: currentHierarchyLevel !== null ? selectedStudy : null,
        country:
          currentHierarchyLevel !== STUDY_HIERARCHY_VALUE && currentHierarchyLevel !== null ? selectedCountry : null,
        site_id: currentHierarchyLevel === SITE_HIERARCHY_VALUE ? selectedSite : null,

        application: process.env.REACT_APP_NAME_TEMP,
        application_section: process.env.REACT_APP_NAME_TEMP,
        application_module_section: 'PATIENT TRIAL NOTEBOOK'
      });
    }
    if (selectedInTrialPatientID !== ids) {
      setPatientDetails({});
      setPatient('');
    } else if (
      hierarchyStudy != selectedStudy ||
      hierarchyCountry != selectedCountry ||
      hierarchySite != selectedSite
    ) {
      dispatch(setActiveStep(0));
      setPatientDetails({});
      setPatient('');
    }
  }, [currentHierarchyLevel, selectedStudy, selectedCountry, selectedSite, selectedInTrialPatientID]);

  useEffect(() => {
    if (isError || patientIdIsError || prescreenIdIsError || codeListIsError || subjectIDIsError) {
      if (isError) {
        setOption([]);
      }
      if (patientIdError) {
        dispatch(setHierarchyPageDetailsLoaded(false));
      }
      const dataErorr: any = error || patientIdError || prescreenIdError || codeListError || subjectIDError;
      if (dataErorr?.status == 500) {
        dispatch(
          setMessage({
            msgDetails: `${dataErorr?.status} : Internal Server Error`,
            severity: 'error'
          })
        );
      } else if (dataErorr?.status == 403) {
        dispatch(
          setMessage({
            msgDetails: `${dataErorr?.status} : Forbbiden Access`,
            severity: 'error'
          })
        );
      }
    }
  }, [isError, patientIdIsError, prescreenIdIsError, subjectIDIsError, codeListIsError]);

  useEffect(() => {
    if (
      isLoading ||
      patientIdIsLoading ||
      prescreenIdIsLoading ||
      subjectIDIsLoading ||
      codeListIsLoading ||
      generateSubjectIDIsLoading ||
      activateCRFIsLoading
    ) {
      dispatch(showLoader());
    } else {
      dispatch(hideLoader());
    }
  }, [
    isLoading,
    patientIdIsLoading,
    prescreenIdIsLoading,
    codeListIsLoading,
    generateSubjectIDIsLoading,
    activateCRFIsLoading,
    subjectIDIsLoading
  ]);
  //for select trail dropdown

  const handleClickListItem = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleMenuItemClick = (_: any, index: number, option: any) => {
    setSelectedIndex(index);
    setAnchorEl(null);
    setSelection(option);
    setPatient('');
    setPatientDetails({});
    if (option === 'Prescreening ID') {
      const prescreenId: any = allPatientDetails.selected_data
        .map((elem: any) => elem?.patient?.prescreening_id)
        .filter((elem: any) => elem !== null);
      prescreenId.length > 0 ? setOption([...new Set(prescreenId)]) : setOption([]);
    } else if (option === 'Patient Identifier') {
      const patientId = allPatientDetails.selected_data
        .map((elem: any) => elem?.patient?.patient_identifier)
        .filter((elem: any) => elem !== null);
      patientId.length > 0 ? setOption([...new Set(patientId)]) : setOption([]);
    } else if (option === 'Subject ID') {
      const subjectID = allPatientDetails.selected_data
        .map((elem: any) => elem?.patient?.subject_id)
        .filter((elem: any) => elem !== null);
      subjectID.length > 0 ? setOption([...new Set(subjectID)]) : setOption([]);
    }
  };

  const handleChangeAutoComplete = (e: any) => {
    batch(() => {
      dispatch(clearCurrentPatientTrailTab());
      dispatch(clearFormLibraryMainData());
      dispatch(setFormLibraryDataIsOpen(false));
      dispatch(setPlannedDate(null));
    });

    if (e) {
      setPatient(e);
      let idObj: any = {
        patient_id: e,
        site_id: selectedSite,
        study_id: selectedStudy,
        country: selectedCountry,
        application: process.env.REACT_APP_NAME_TEMP,
        application_section: process.env.REACT_APP_NAME_TEMP,
        application_module_section: 'PATIENT TRIAL NOTEBOOK'
      };
      if (selection === 'Patient Identifier') {
        idObj = {
          search_scope: 'PATIENT_IDENTIFIER',
          ...idObj
        };
      } else if (selection === 'Prescreening ID') {
        idObj = {
          search_scope: 'PRESCREENING_ID',
          ...idObj
        };
      } else if (selection === 'Subject ID') {
        idObj = {
          search_scope: 'SUBJECT_ID',
          ...idObj
        };
      }
      getPatientDataAPI(idObj);
    } else {
      setPatient('');
      setPatientDetails({});
    }
  };

  const navigateToInTrialPatient = () => {
    dispatch(setPath('inTrialPatient'));
    const currentTab: any = tabsData.find((elem: any) => elem.key === 'trialEligiblePatients');
    if (currentTab?.index) {
      setTabVal(currentTab.index);
    }
  };

  const handleOpen = async () => {
    setOpenProcess(true);
    if (!patinetDetails?.subject_id) {
      await getLatestSubjectID({
        site_id: selectedSite,
        study_id: selectedStudy,
        country: selectedCountry
      });
    }
  };
  const handleCloseProcess = () => setOpenProcess(false);
  const actionConfiguredFormsSteps = !patinetDetails?.subject_id
    ? 0
    : !patinetDetails?.crf_activated
    ? 1
    : !patinetDetails?.enrollment_reason
    ? 2
    : 3;

  const [subjectIDBeforeGeneration, setSubjectIDBeforeGeneration] = useState<any>('');

  useEffect(() => {
    if (!latestSubjectID && latestSubjectIDIsSuccess && !latestSubjectIDIsLoading) {
      setSubjectIDBeforeGeneration('E0001');
    } else if (latestSubjectIDIsSuccess && !latestSubjectIDIsError) {
      setSubjectIDBeforeGeneration(latestSubjectID);
    }
  }, [latestSubjectID, latestSubjectIDIsSuccess, latestSubjectIDIsLoading]);

  const handleConfirmStep = async () => {
    setFormActionConfirmationPopup(true);
    /*Generate Subject ID - Start*/
    if (!patinetDetails?.subject_id) {
      if (!latestSubjectID && latestSubjectIDIsSuccess) {
        setSubjectIDBeforeGeneration('E0001');
      } else if (latestSubjectIDIsSuccess && !latestSubjectIDIsError) {
        setSubjectIDBeforeGeneration(latestSubjectID);
      } else if (latestSubjectIDIsError) {
        setFormActionConfirmationPopup(false);
        const errorData: any = latestSubjectIDError;
        if (errorData?.status == 500 || errorData?.status == 502 || errorData?.status == 503) {
          dispatch(
            setMessage({
              msgDetails: `${errorData?.status} : Internal Server Error`,
              severity: 'error'
            })
          );
        } else if (errorData?.status == 403) {
          dispatch(
            setMessage({
              msgDetails: `${errorData?.status} : Forbbiden Access`,
              severity: 'error'
            })
          );
        }
      }
    }

    /*Generate Subject ID - End*/
    /*Activate CRF - Start*/
    if (patinetDetails?.subject_id) {
      // do Nothing
    }
    /*Activate CRF - End*/
    /*Enroll Patient - Start*/
    /*Enroll Patient - End*/
    setOpenProcess(false);
  };
  const generateSubjectIDForm = assignedForms?.find((form: any) => form.generate_subject_id == true);
  const activateCRFForm = assignedForms?.find((form: any) => form.activate_crf == true);
  const enrollPatientForm = assignedForms?.find((form: any) => form.enrollment == true);

  const handleFormActionClose = () => {
    setFormActionConfirmationPopup(false);
    setEnrollReason('');
  };

  const handleFormActionConfirm = async () => {
    /*Respective API call*/
    if (!patinetDetails?.subject_id) {
      const dataObj = {
        subject_id: subjectIDBeforeGeneration,
        toolkit_form_id: generateSubjectIDForm?.id,
        updated_by: `${user?.firstName} ${user?.lastName}`
      };

      procedPritrails('Actual', screeningDate);
      await generateSubjectID({
        data: dataObj,
        parent_id: patinetDetails?.patient_identifier,
        site_id: selectedSite,
        study_id: selectedStudy,
        country: selectedCountry
      });
    }
    if (patinetDetails?.subject_id && !patinetDetails?.crf_activated) {
      await activateCRF({
        data: { toolkit_form_id: activateCRFForm?.id },
        parent_id: patinetDetails?.patient_identifier,
        site_id: selectedSite,
        study_id: selectedStudy,
        country: selectedCountry
      });
    }
    if (patinetDetails?.crf_activated) {
      if (enrollReason && enrollReason?.length > 0) {
        await enrollSubject({
          data: {
            toolkit_form_id: enrollPatientForm?.id,
            enrollment_randomized: false,
            enrollment_reason: enrollReason,
            updated_by: `${user?.firstName} ${user?.lastName}`
          },
          parent_id: patinetDetails?.patient_identifier,
          site_id: selectedSite,
          study_id: selectedStudy,
          country: selectedCountry
        });
      } else {
        dispatch(setMessage({ msgDetails: 'Enrollment Reason is Mandatory', severity: 'error' }));
      }
    }
    getPatientDataAPI({
      patient_id: patinetDetails?.patient_identifier,
      study_id: selectedStudy,
      country: selectedCountry,
      site_id: selectedSite,
      search_scope: 'PATIENT_IDENTIFIER',
      // application: process.env.REACT_APP_NAME,
      // application_section: process.env.REACT_APP_NAME,
      application: process.env.REACT_APP_NAME_TEMP,
      application_section: process.env.REACT_APP_NAME_TEMP,
      application_module_section: 'PATIENT TRIAL NOTEBOOK'
    });
    if (actionConfiguredFormsSteps == 2) {
      enrollReason.length > 0 && setFormActionConfirmationPopup(false);
      setEnrollReason('');
    } else {
      setFormActionConfirmationPopup(false);
    }
    setOpenProcess(false);
  };

  const procedPritrails = (dateType: any, dateValue: any) => {
    PreTrialEvaluation({
      data: { date_type: dateType, screening_date: getServerDateOrInvalidDayJs(dateValue) },
      parent_id: patinetDetails?.patient_identifier,
      site_id: selectedSite,
      study_id: selectedStudy,
      country: selectedCountry
    });
  };

  useEffect(() => {
    if (!generateSubjectIDIsLoading && generateSubjectIDIsSuccess) {
      dispatch(
        setMessage({
          msgDetails: `Subject ID ${subjectIDBeforeGeneration} is generated `,
          severity: 'success'
        })
      );
    } else if (generateSubjectIDIsError) {
      const errorData: any = generateSubjectIDError;
      if (errorData?.status == 500 || errorData?.status == 502 || errorData?.status == 503) {
        dispatch(
          setMessage({
            msgDetails: `${errorData?.status} : Internal Server Error`,
            severity: 'error'
          })
        );
      } else if (errorData?.status == 403) {
        dispatch(
          setMessage({
            msgDetails: `${errorData?.status} : Forbbiden Access`,
            severity: 'error'
          })
        );
      }
    }
  }, [
    generateSubjectIDIsLoading,
    generateSubjectIDIsError,
    generateSubjectIDError,
    generateSubjectIDIsSuccess,
    generateSubjectIDData
  ]);

  useEffect(() => {
    if (!activateCRFIsLoading && activateCRFIsSuccess) {
      dispatch(
        setMessage({
          msgDetails: `Activation of CRF is successful  `,
          severity: 'success'
        })
      );
    } else if (activateCRFIsError) {
      const errorData: any = activateCRFError;
      if (errorData?.status == 500 || errorData?.status == 502 || errorData?.status == 503) {
        dispatch(
          setMessage({
            msgDetails: `${errorData?.status} : Internal Server Error`,
            severity: 'error'
          })
        );
      } else if (errorData?.status == 403) {
        dispatch(
          setMessage({
            msgDetails: `${errorData?.status} : Forbbiden Access`,
            severity: 'error'
          })
        );
      }
    }
  }, [activateCRFIsLoading, activateCRFIsError, activateCRFError, activateCRFIsSuccess, activateCRFData]);

  useEffect(() => {
    if (!enrollSubjectIsLoading && enrollSubjectIsSuccess) {
      dispatch(
        setMessage({
          msgDetails: `Enrollment is successful`,
          severity: 'success'
        })
      );
      setEnrollReason('');
    } else if (enrollSubjectIsError) {
      const errorData: any = enrollSubjectError;
      if (errorData?.status == 500 || errorData?.status == 502 || errorData?.status == 503) {
        dispatch(
          setMessage({
            msgDetails: `${errorData?.status} : Internal Server Error`,
            severity: 'error'
          })
        );
      } else if (errorData?.status == 403) {
        dispatch(
          setMessage({
            msgDetails: `${errorData?.status} : Forbbiden Access`,
            severity: 'error'
          })
        );
      }
    }
  }, [enrollSubjectIsLoading, enrollSubjectIsError, enrollSubjectError, enrollSubjectIsSuccess, enrollSubjectData]);

  useEffect(() => {
    if (!preTrialEvaluationLoading && preTrialEvaluationIsSuccess) {
      dispatch(
        setMessage({
          msgDetails: `Pre-Trial Evaluation is successful`,
          severity: 'success'
        })
      );
      dispatch(setPlannedDate(planningDate));
      setOpenProceed(false);
      setEnrollReason('');
    } else if (preTrialEvaluationIsError) {
      const errorData: any = preTrialEvaluationError;
      if (errorData?.status == 500 || errorData?.status == 502 || errorData?.status == 503) {
        dispatch(
          setMessage({
            msgDetails: `${errorData?.status} : Internal Server Error`,
            severity: 'error'
          })
        );
      } else if (errorData?.status == 403) {
        dispatch(
          setMessage({
            msgDetails: `${errorData?.status} : Forbbiden Access`,
            severity: 'error'
          })
        );
      } else if (errorData?.status == 404) {
        dispatch(
          setMessage({
            msgDetails: errorData?.data?.context?.message,
            severity: 'error'
          })
        );
      }
    }
  }, [
    preTrialEvaluationLoading,
    preTrialEvaluationIsError,
    preTrialEvaluationError,
    preTrialEvaluationIsSuccess,
    preTrialEvaluationData
  ]);

  useEffect(() => {
    if (!preTrialEvaluationLoading && preTrialEvaluationIsSuccess) {
      dispatch(
        setMessage({
          msgDetails: `Pre-Trial Evaluation is successful`,
          severity: 'success'
        })
      );
      dispatch(setPlannedDate(planningDate));
      setOpenProceed(false);
      setEnrollReason('');
    } else if (preTrialEvaluationIsError) {
      const errorData: any = preTrialEvaluationError;
      if (errorData?.status == 500 || errorData?.status == 502 || errorData?.status == 503) {
        dispatch(
          setMessage({
            msgDetails: `${errorData?.status} : Internal Server Error`,
            severity: 'error'
          })
        );
      } else if (errorData?.status == 403) {
        dispatch(
          setMessage({
            msgDetails: `${errorData?.status} : Forbbiden Access`,
            severity: 'error'
          })
        );
      } else if (errorData?.status == 404) {
        dispatch(
          setMessage({
            msgDetails: errorData?.data?.context?.message,
            severity: 'error'
          })
        );
      }
    }
  }, [
    preTrialEvaluationLoading,
    preTrialEvaluationIsError,
    preTrialEvaluationError,
    preTrialEvaluationIsSuccess,
    preTrialEvaluationData
  ]);

  const formActionConfirmTitle =
    actionConfiguredFormsSteps == 0
      ? `${generateSubjectIDForm?.name} Completion`
      : actionConfiguredFormsSteps == 1
      ? `${activateCRFForm?.name} Completion`
      : enrollPatientForm?.name;

  const validateIsSignComplete = (formData: any) => {
    if (!formData?.e_sign_form || (formData?.e_sign_form && formData.signed_by != null && formData.signed_on != null)) {
      return false;
    } else if (formData?.e_sign_form && formData.signed_by == null && formData.signed_on == null) {
      return true;
    }
  };

  const generateSubjectIDPopup = () => (
    <>
      <Typography variant="body1" gutterBottom sx={{ mb: 1, fontSize: 16 }}>
        The following Subject ID will be generated
      </Typography>
      <FormControl fullWidth sx={{ mb: '16px' }}>
        <InputLabel id="subject-id" style={{ marginLeft: '-14px', marginTop: '8px' }}>
          Subject ID
        </InputLabel>
        <Select
          labelId="subject-id"
          id="demo-simple-select"
          disabled
          variant="standard"
          value={subjectIDBeforeGeneration}
          label="Subject ID"
        >
          <MenuItem value={subjectIDBeforeGeneration}>{subjectIDBeforeGeneration}</MenuItem>
        </Select>
      </FormControl>

      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <DatePicker
          label="Screening Date"
          disableFuture
          disablePast={false}
          inputFormat={userPreferedDateFormat.toUpperCase()}
          value={screeningDate}
          onChange={(newValue: any) => {
            if (newValue !== null) {
              const changedDate = getServerDateOrInvalidDayJs(newValue);
              if (changedDate?.length === 10 && changedDate !== 'Invalid Date') {
                const isValidProceedDate = moment(newValue.$d).isAfter(new Date());
                setIsScreenDisabled(isValidProceedDate);
                setScreeningDate(newValue);
              } else {
                setIsScreenDisabled(true);
              }
            }
          }}
          renderInput={params => (
            <TextField {...params} variant="standard" sx={{ width: '100%' }} placeholder="Screening Date" />
          )}
        />
      </LocalizationProvider>
    </>
  );
  const activatePopup = () => (
    <>
      <div style={{ marginBottom: '20px' }}>I confirm that {activateCRFForm?.name} is completed.</div>
      <div>Study CRFs and schedule for Subject {patinetDetails?.subject_id} will now be activated.</div>
    </>
  );

  const [enrollReason, setEnrollReason] = useState('');
  const enrollPopup = () => (
    <Grid container spacing={1}>
      <Grid item xs={6}>
        Is subject ready to be randomized
      </Grid>
      <Grid item xs={4}>
        <RadioGroup defaultValue="false" row style={{ marginTop: '-8px' }}>
          <FormControlLabel value="true" control={<Radio />} label="Yes" disabled />
          <FormControlLabel value="false" control={<Radio />} label="No" />
        </RadioGroup>
      </Grid>
      <Grid item xs={12}>
        <TextField label="Subject ID" variant="standard" defaultValue={patinetDetails?.subject_id} disabled fullWidth />
      </Grid>
      <Grid item xs={12}>
        <TextField
          label="Reason"
          variant="standard"
          value={enrollReason}
          onChange={e => setEnrollReason(e.target.value)}
          inputProps={{ maxLength: 250 }}
          fullWidth
          required
        />
      </Grid>
    </Grid>
  );
  const [isProceededDisabled, setIsProceededDisabled] = useState(false);
  const [isFieldChanged, setisFieldChanged] = useState(false);
  const [openExitPopup, setOpenExitPopup] = useState(false);
  const handleBack = () => {
    if (isBackButton && formLibraryDataIsOpen) {
      dispatch(setFormLibraryDataIsOpen(false));
    } else if (isBackButton && selectedSubjectInfo?.patient_identifier) {
      const currentTab: any = tabsData.find((elem: any) => elem.key === 'dataReview');
      if (currentTab?.index) {
        setTabVal(currentTab.index);
      }
      dispatch(setSelectedSubject(''));
    } else if (isBackButton) {
      dispatch(clearSelectedIntrialPatient());
      dispatch(clearIntrialPatientInfo());
      dispatch(clearSubjectInfo());
      dispatch(setPlannedDate(null));
      dispatch(setActiveStep(0));

      navigateToInTrialPatient();
    } else if (formLibraryDataIsOpen) {
      dispatch(setFormLibraryDataIsOpen(false));
    }
    setOpenExitPopup(false);
  };
  const handleBcakButton = () => {
    if (isFieldChanged) {
      setOpenExitPopup(true);
      return;
    }
    handleBack();
  };
  const handleProceed = () => {
    procedPritrails('Planned', planningDate);
  };
  const [openProceedPopup, setOpenProceed] = React.useState(false);

  const handleClickOpenProceed = () => {
    setOpenProceed(true);
  };
  const handleCloseModal = () => {
    setOpenProceed(false);
  };

  return (
    <>
      <>
        {isBackButton || formLibraryDataIsOpen ? (
          <Box className="mainBackBtnWrap">
            <Button startIcon={<ArrowBackIcon fontSize="small" />} onClick={handleBcakButton}>
              Back
            </Button>
          </Box>
        ) : null}
        {formLibraryDataIsOpen && formLibraryMainData != null ? (
          <FormLibraryData
            patinetDetails={patinetDetails}
            isFieldChanged={isFieldChanged}
            setisFieldChanged={setisFieldChanged}
          />
        ) : sitePermissionData ? (
          <>
            <Grid container spacing={2} mb={2}>
              <Grid item md={12} display="flex" flexDirection="row" alignItems="flex-end">
                <Box sx={{ maxWidth: 190 }}>
                  <List component="nav" aria-label="Select Filter" className="lightBlue-selectBtn" sx={{ py: 0 }}>
                    <ListItem
                      id="lock-button"
                      aria-haspopup="listbox"
                      aria-controls="lock-menu"
                      aria-label="Select filter option"
                      aria-expanded={open ? 'true' : undefined}
                      onClick={handleClickListItem}
                      secondaryAction={
                        <IconButton aria-label="select" sx={{ p: 0 }}>
                          <ArrowDropDownIcon />
                        </IconButton>
                      }
                    >
                      <ListItemText primary={searchScope[selectedIndex]} />
                    </ListItem>
                  </List>
                  <Menu
                    id="lock-menu"
                    anchorEl={anchorEl}
                    open={open}
                    onClose={handleClose}
                    MenuListProps={{
                      'aria-labelledby': 'lock-button',
                      role: 'listbox'
                    }}
                    className="lightBlue-selectDD"
                  >
                    {searchScope.map((option: any, index: any) => (
                      <MenuItem
                        key={option}
                        defaultValue={option}
                        // disabled={index === 0}
                        selected={index === selectedIndex}
                        onClick={event => handleMenuItemClick(event, index, option)}
                      >
                        <ListItemIcon>
                          <Check />
                        </ListItemIcon>
                        {option}
                      </MenuItem>
                    ))}
                  </Menu>
                </Box>
                <Box sx={{ display: 'flex', flex: 1, alignItems: 'end' }}>
                  <Autocomplete
                    id="standard-select-currency-native"
                    fullWidth
                    disablePortal
                    options={option}
                    value={patient}
                    defaultValue={ids}
                    onChange={(_: any, newValue: string) => {
                      handleChangeAutoComplete(newValue);
                    }}
                    renderInput={params => (
                      <TextField
                        {...params}
                        variant="standard"
                        placeholder={`Search Patients`}
                        InputProps={{
                          ...params.InputProps,
                          startAdornment: (
                            <InputAdornment position="start" sx={{ pl: 1 }}>
                              <SearchIcon />
                            </InputAdornment>
                          )
                        }}
                      />
                    )}
                  />
                </Box>
              </Grid>
            </Grid>
            {allPatientDetails ? (
              <>
                <Box className="SummaryDetails_wrap">
                  <Typography variant="h5" component="h5" sx={{ mb: 2 }}>
                    Subject Summary
                  </Typography>
                  <Grid container spacing={2} rowSpacing={1}>
                    {rowData.map((ele: any, index: number) => (
                      <Grid item md={4} key={index}>
                        <Typography variant="h6" component="h6">
                          {ele.textValue}:&nbsp;
                          <span className="results">
                            {ele.type === 'date'
                              ? preferedDateFormat(patinetDetails?.[ele.value])
                              : patinetDetails?.[ele.value]}
                          </span>
                        </Typography>
                      </Grid>
                    ))}
                  </Grid>
                </Box>
                <Grid container spacing={2} alignItems="left">
                  <Grid item xs>
                    <Box sx={{ width: '100%', my: 2 }}>
                      <Stepper
                        activeStep={activeStep}
                        alternativeLabel
                        className="stepperClass"
                        sx={{
                          '& .MuiStepIcon-root.Mui-completed': {
                            color: '#4CAF50 !important',
                            marginLeft: '-10px'
                          }
                        }}
                      >
                        {steps?.map((label, index) => (
                          <Step key={label} completed={index == 0 ? preTrailplannedDate : false}>
                            <StepLabel
                              optional={
                                index === 0 &&
                                checkPermission('add_patient_screening_date') &&
                                patinetDetails?.patient_identifier &&
                                preTrailplannedDate == null ? (
                                  <Link href="#?" onClick={handleClickOpenProceed} underline="always">
                                    Proceed
                                  </Link>
                                ) : null
                              }
                            >
                              {label}
                              {index === 1 &&
                              selectedPatientTrailTab == 2 &&
                              assignedForms.length > 0 &&
                              patinetDetails?.patient_identifier ? (
                                <Typography>
                                  {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                                  <a href="#" className="stepsCompletion" onClick={handleOpen}>
                                    {actionConfiguredFormsSteps}/3 Complete
                                  </a>
                                </Typography>
                              ) : null}
                            </StepLabel>
                          </Step>
                        ))}
                      </Stepper>
                    </Box>
                  </Grid>
                  <Grid item sx={{ width: 'fit-content' }}>
                    <Button sx={{ mt: 1.25 }} endIcon={<ArrowForwardIcon />}>
                      Next Step
                    </Button>
                  </Grid>
                </Grid>
                {patinetDetails.patient_identifier ? (
                  <PatientTrailNoteBookTabs
                    parent_id={patinetDetails?.patient_identifier}
                    prescreen_id={patinetDetails?.prescreening_id}
                    actionConfiguredFormsSteps={actionConfiguredFormsSteps}
                  />
                ) : null}
              </>
            ) : (
              <Grid container justifyContent={'center'} alignItems="center" style={{ minHeight: '40vh' }}>
                <h4>No data available!</h4>
              </Grid>
            )}
          </>
        ) : (
          !isLoading &&
          !patientIdIsLoading &&
          !prescreenIdIsLoading &&
          !subjectIDIsLoading &&
          !codeListIsLoading &&
          !generateSubjectIDIsLoading &&
          !activateCRFIsLoading &&
          sitePermissionData === false && (
            <div className="no-data-class">
              <h3>No Data access available!</h3>
            </div>
          )
        )}
      </>
      <PopupComponent open={openprocess}>
        <DialogTitle>Screening</DialogTitle>
        <DialogContent className="tsda_prescreenDialog">
          <Typography variant="subtitle1">Steps to complete before moving on to the next phase:</Typography>
          <DialogContentText>
            {/* <Alert severity="info">Confirm the forms to be sent to Prescreen ID by listing the selected forms </Alert> */}
            <List sx={{ ml: -2 }}>
              <ListItem>
                <ListItemIcon sx={{ minWidth: '30px!important' }}>
                  {patinetDetails?.subject_id ? <CheckCircleIcon sx={{ color: '#4CAF50' }} /> : <PendingOutlined />}
                </ListItemIcon>
                <ListItemText primary={`${generateSubjectIDForm?.name} - Generate Subject ID`} />
              </ListItem>
              <ListItem>
                <ListItemIcon sx={{ minWidth: '30px!important' }}>
                  {patinetDetails?.crf_activated ? <CheckCircleIcon sx={{ color: '#4CAF50' }} /> : <PendingOutlined />}
                </ListItemIcon>
                <ListItemText primary={`${activateCRFForm?.name} - Activate CRF`} />
              </ListItem>
              <ListItem>
                <ListItemIcon sx={{ minWidth: '30px!important' }}>
                  {patinetDetails?.enrollment_reason ? (
                    <CheckCircleIcon sx={{ color: '#4CAF50' }} />
                  ) : (
                    <PendingOutlined />
                  )}
                </ListItemIcon>
                <ListItemText primary={`${enrollPatientForm?.name} - Enroll`} />
              </ListItem>
            </List>
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseProcess} className="grey-btn">
            Cancel
          </Button>
          {!patinetDetails?.enrollment_reason ? (
            <Button
              disabled={
                (!patinetDetails?.subject_id
                  ? validateIsSignComplete(generateSubjectIDForm)
                  : !patinetDetails?.crf_activated
                  ? validateIsSignComplete(activateCRFForm)
                  : validateIsSignComplete(enrollPatientForm)) || !checkPermission('complete_toolkit_forms')
              }
              onClick={handleConfirmStep}
            >
              {!patinetDetails?.subject_id
                ? 'Generate Subject Id'
                : !patinetDetails?.crf_activated
                ? 'Activate CRF'
                : 'Enroll Patient'}
            </Button>
          ) : null}
        </DialogActions>
      </PopupComponent>
      <PopupComponent open={formActionConfirmationPopup} className="popup-component">
        <DialogTitle sx={{ textTransform: 'capitalize' }}>{formActionConfirmTitle}</DialogTitle>

        <DialogContent sx={{ minWidth: '400px' }}>
          <DialogContentText>
            {!patinetDetails?.subject_id
              ? generateSubjectIDPopup()
              : !patinetDetails?.crf_activated
              ? activatePopup()
              : enrollPopup()}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button className="grey-btn" onClick={handleFormActionClose}>
            Cancel
          </Button>
          <Button onClick={handleFormActionConfirm} disabled={isScreenDisabled} autoFocus>
            Confirm
          </Button>
        </DialogActions>
      </PopupComponent>
      <PopupComponent open={openExitPopup}>
        <DialogTitle id="alert-dialog-title">{'Confirm Exit'}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">{unSavedWarning}</DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => {
              setOpenExitPopup(false);
            }}
            className="grey-btn"
          >
            Close
          </Button>
          <Button onClick={handleBack}>Ok</Button>
        </DialogActions>
      </PopupComponent>

      <PopupComponent open={openProceedPopup} className="popup-component">
        <DialogTitle id="proceed-trail" sx={{ fontSize: 20 }}>
          Pre-Trial Evaluation
          <Tooltip title="Close" placement="top">
            <IconButton onClick={handleCloseModal} className="closeBtnModal">
              <CloseIcon />
            </IconButton>
          </Tooltip>
        </DialogTitle>
        <DialogContent sx={{ minWidth: 460 }}>
          <Typography variant="body1" sx={{ fontSize: 16, marginBottom: '24px' }}>
            Progress Subject to perform pre-trial assessments
          </Typography>

          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DatePicker
              label="Planned Screening Date"
              disableFuture={false}
              disablePast
              inputFormat={userPreferedDateFormat.toUpperCase()}
              value={planningDate}
              onChange={(newValue: any) => {
                if (newValue !== null) {
                  const changedDate = getServerDateOrInvalidDayJs(newValue);
                  if (changedDate?.length === 10 && changedDate !== 'Invalid Date') {
                    const isValidProceedDate = moment(newValue.$d).diff(new Date(), 'days') < 0;
                    setIsProceededDisabled(isValidProceedDate);
                    setPlanningDate(newValue);
                  } else {
                    setIsProceededDisabled(true);
                  }
                }
              }}
              renderInput={params => (
                <TextField {...params} variant="standard" sx={{ width: '100%' }} placeholder="Planned Screening Date" />
              )}
            />
          </LocalizationProvider>
        </DialogContent>
        <DialogActions
          sx={{
            px: 2,
            pb: 2,
            '& .MuiButton-root + .MuiButton-root': { marginLeft: '16px' }
          }}
        >
          {/* <Button
            onClick={() => {
              setOpenProceed(false);
            }}
            // className="grey-btn"
            variant="outlined"
          >
            Reject
          </Button> */}
          <Button onClick={handleProceed} variant="contained" disabled={isProceededDisabled}>
            Proceed
          </Button>
        </DialogActions>
      </PopupComponent>
    </>
  );
};
